<template>
  <dialog-template 
    :append-to-body="true"
    :headerTitle="allInfo.title" 
    :visible.sync="dialogVisible" 
    :width="'400px'">
    <p class="question text-popper" v-textPopper>{{ allInfo.question }}</p>
    <p class="tips">{{ allInfo.tips }}</p>
    <div class="btn-wrapper" slot="footer">
        <el-button :loading="loading"  type="primary" size="medium" @click="confirm">确认</el-button>
        <el-button type="default" size="medium" @click="dialogVisible = false">取消</el-button>
    </div>
  </dialog-template>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      up: true,
      options: {}
    }
  },
  props: {
      loading: Boolean
  },
  computed: {
      allInfo() {
          const obj = {
              up: {
                  title: '商品上架',
                  question: `确定上架商品 ${this.options.goods_name} 吗？`,
                  tips: '下架商品重新上架后可再次出售'
              },
              down: {
                  title: '商品下架',
                  question: `确定下架商品 ${this.options.goods_name} 吗？`,
                  tips: '下架后商品将不可出售'
              }
          }
          const val = this.up ? 'up' : 'down'
          return obj[val]
      },
  },
  methods: {
    open(options = {}) {
      this.options = options
      this.up = options.up
      this.dialogVisible = true
    },

    confirm() {
        this.options.callback && this.options.callback(() => this.dialogVisible = false)
    }
  }
}
</script>

<style lang="scss" scoped>
p {
    text-align: center;
}

.question {
    height: 20px;
    line-height: 20px;
    color: #333;
    font-size: 16px;
    font-weight: 500;

    span {
        font-weight: bold;
    }
}

.tips {
    height: 16px;
    line-height: 16px;
    margin-top: 8px;
    font-size: 14px;
    color: #666;
}

.btn-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
